<template>
    <div class="uebung-activitas-print p-4">
        <div class="flex justify-center mb-6">
            <Button size="large" icon="fa-solid fa-check-circle" label="Speichern & Zurück zur Übungsbibliothek"
                @click="saveAndReturn" :loading="isLoading"></Button>
        </div>
        <h1 class="p-4">Hier sehen Sie eine Vorschau der Print-Version:</h1>

        <div class="paper max-w-a4-hochformat bg-white">
            <div class="uebung_content_info p-3 flex flex-col">
                <div v-html="store.uebung.title" class="text-xl text-grey-600 italic font-bold"></div>
                <div v-html="store.uebung.description" class="text-grey-600 italic"></div>
            </div>
            <div class="p-8">
                <!-- Grid für die Wortkarten in exakt 3 Spalten -->
                <div class="grid grid-cols-3 gap-4">
                    <div v-for="(word, index) in store.uebung.content_data" :key="index"
                        class="relative bg-white rounded-lg shadow-md p-4 border border-gray-200 hover:shadow-xl transition-shadow print:border-dashed print:m-2 print:p-2">
                        <!-- Wortkarte -->
                        <div class="mt-4 flex justify-center">
                            <uebung-activitas-single-card :editable="editable"></uebung-activitas-single-card>
                        </div>

                        <!-- Wort/Lemma Anzeige -->
                        <div class="mt-3 text-center text-xl font-serif font-bold text-gray-800" v-html="word.lemma">
                        </div>
                    </div>
                </div>
            </div>
            <div class="p-1 italic text-xs flex flex-row justify-end text-grey-500 items-center">
                <i class="hi hi-sentence mr-1"></i>hermeneus
            </div>
        </div>
    </div>
</template>
<script>
import UebungActivitasSingleCard from "./UebungActivitasSingleCardActivitySwitcher.vue";
import { useUebungActivitasCreateStore } from "./stores/uebungActivitasCreateStore.js";
import { haxiosAPIClient } from "@js/haxios/haxios.js";
import {EventBus} from "@js/hermeneus.eventbus/eventbus.js";
export default {
    name: "uebung-activitas-create-submit",
    data() {
        return {
            store: useUebungActivitasCreateStore(),
            editable: false,
            isLoading: false
        }
    },
    components: {
        'uebung-activitas-single-card': UebungActivitasSingleCard
    },
    methods: {

        saveAndReturn() {
            this.isLoading = true;
            haxiosAPIClient.post('/uebungen/store/uebung-activitas', {data: this.store.uebung}).then(async response => {
                this.isLoading = false;
                EventBus.$emit('close-create-uebung-modal');
                EventBus.$emit('requested-uebungen-fetch');
                this.$IrisMessenger.bar({
                    type: 'success',
                    message: 'Die Übung wurde erfolgreich gespeichert und kann nun verwendet werden.',
          callback: null,
          selfDestructTimer: 3000
                })

            })
        },

    },

}
</script>